module.exports = __webpack_public_path__ + "static/media/wordpress.9f6a5beb.svg";